import type { AuthUser } from '@/types/auth/authTypes';

import { temPermissao, temPermissaoNaArea } from './permissoesEquipeInterna';

type UsuarioDaEquipe = Pick<AuthUser, 'tipoUsuario' | 'permissoes'>;

/** Telas da Secretaria na ordem do menu: a pessoa cai na primeira que pode abrir. */
const TELAS_DA_SECRETARIA: ReadonlyArray<{
  rota: string;
  abre: (user: UsuarioDaEquipe) => boolean;
}> = [
  { rota: '/admin-geral/secretaria', abre: (user) => temPermissao(user, 'painel.visualizar') },
  { rota: '/admin-geral/secretaria/triagem', abre: (user) => temPermissaoNaArea(user, 'triagem') },
  { rota: '/admin-geral/secretaria/prazos', abre: (user) => temPermissaoNaArea(user, 'prazos') },
  {
    rota: '/admin-geral/secretaria/processos',
    abre: (user) => temPermissaoNaArea(user, 'processos'),
  },
  { rota: '/admin-geral/secretaria/ar', abre: (user) => temPermissaoNaArea(user, 'ar') },
];

/**
 * Para onde a equipe interna vai depois do login, em vez da home dos clientes (Bianca,
 * 29/10/2026): o admin da PLATAFORMA (`tipoUsuario === 'ADMIN'`, não o admin de um escritório
 * cliente, que é `papelEscritorio`) vai para o Admin geral; a `SECRETARIA`, para a primeira tela
 * da Secretaria que as permissões dela abrem — sem nenhuma, para o Painel geral, que mostra
 * "Acesso restrito". Demais perfis: `null` (seguem o destino de sempre).
 *
 * @example destinoInicialDaEquipeInterna({ tipoUsuario: 'SECRETARIA', permissoes: ['triagem.aprovar'] })
 * // '/admin-geral/secretaria/triagem'
 */
export function destinoInicialDaEquipeInterna(user: UsuarioDaEquipe): string | null {
  if (user.tipoUsuario === 'ADMIN') return '/admin-geral';
  if (user.tipoUsuario !== 'SECRETARIA') return null;
  return TELAS_DA_SECRETARIA.find((tela) => tela.abre(user))?.rota ?? '/admin-geral/secretaria';
}
